/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiAssignmentUser
 */
export interface InternalApiAssignmentUser {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAssignmentUser
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAssignmentUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAssignmentUser
     */
    name?: string;
}

/**
 * Check if a given object implements the InternalApiAssignmentUser interface.
 */
export function instanceOfInternalApiAssignmentUser(value: object): value is InternalApiAssignmentUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function InternalApiAssignmentUserFromJSON(json: any): InternalApiAssignmentUser {
    return InternalApiAssignmentUserFromJSONTyped(json, false);
}

export function InternalApiAssignmentUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAssignmentUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function InternalApiAssignmentUserToJSON(json: any): InternalApiAssignmentUser {
    return InternalApiAssignmentUserToJSONTyped(json, false);
}

export function InternalApiAssignmentUserToJSONTyped(value?: InternalApiAssignmentUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
    };
}

